import { ArrowUp, Linkedin } from "lucide-react";

const EMAIL = "fatheadproductions0@gmail.com";
const LINKEDIN = "https://www.linkedin.com/in/fat-head-advertisements-863963420/";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="relative border-t border-white/10 bg-black">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-16 pb-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
          <div>
            <span className="text-xs tracking-[0.3em] uppercase text-yellow-400 font-semibold">
              fatheadadvertisements.com
            </span>
            <a
              data-testid="footer-email"
              href={`mailto:${EMAIL}`}
              className="mt-4 block text-white text-xl md:text-2xl hover:text-yellow-400 transition-colors break-all"
            >
              {EMAIL}
            </a>
            <a
              data-testid="footer-linkedin"
              href={LINKEDIN}
              target="_blank"
              rel="noopener noreferrer"
              className="group mt-5 inline-flex items-center gap-2 text-sm uppercase tracking-widest text-zinc-400 hover:text-yellow-400 transition-colors"
            >
              <Linkedin size={16} className="text-yellow-400" />
              LinkedIn
            </a>
          </div>

          <button
            data-testid="footer-back-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="group inline-flex items-center gap-2 text-sm uppercase tracking-widest text-zinc-400 hover:text-yellow-400 transition-colors self-start"
          >
            Back to top
            <ArrowUp size={16} className="group-hover:-translate-y-1 transition-transform" />
          </button>
        </div>

        <div className="mt-14 overflow-hidden">
          <h2 className="font-display font-bold uppercase tracking-tight text-white leading-[0.85] text-[15vw] lg:text-[13vw] whitespace-nowrap">
            Fat Head<span className="text-yellow-400">.</span>
          </h2>
        </div>

        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs uppercase tracking-widest text-zinc-600">
          <span>© {new Date().getFullYear()} Fat Head Advertisements</span>
          <span>Digital Advertising & Brand Scaling</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
